import axios from 'axios'
import draftToHtml from 'draftjs-to-html'
import { convertToRaw } from 'draft-js'
import { StakeVault_CONTRACT_ADDRESS } from '@utils/addressHelper'
import { getWeb3, getProviderWeb3 } from '@utils/walletHelper'
import { isValidUrl } from '@utils/dataHelper'
import StakeVault_ABI from '@abis/stakeVault.json'
import { TOKENS_INFO } from '@utils/tokenHelper'
import DEAL_LOGO from '@images/deal_logo.png'

const web3 = getWeb3()
const provierWeb3 = getProviderWeb3()
const API_KEY = process.env.REACT_APP_PINATA_API_KEY
const API_SECRET = process.env.REACT_APP_PINATA_API_SECRET
const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const getAdminAddress = async () => {
  const _web3 = provierWeb3;
  const stakeVault = new _web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
  
  return await stakeVault.methods.owner().call();
}

export const getAppClosed = async () => {
  const _web3 = provierWeb3;
  const stakeVault = new _web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
  
  return await stakeVault.methods.closeAll().call();
}

export const getDealList = async (account, flag) => {
  const _web3 = provierWeb3

  if (_web3) {
    const stakeVault = new _web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    let dealIds = [];
    if (flag === "all_deals")
      dealIds = await stakeVault.methods.getDealIds(1, 0).call();
    if (flag === "my_deals" && account !== '')
      dealIds = await stakeVault.methods.getSponsorDeals(account).call();
    if (flag === "my_stakes" && account !== '') {
      let stakeIds = await stakeVault.methods.getInvetorStakes(account).call();
      dealIds = await getDealIdsFromStakes(stakeVault, stakeIds)
    }
    let data = await Promise.all(
      fetchDealData(stakeVault, account, dealIds)
    );

    if (flag === "all_deals") {
      data = data.filter((item) => item.status !== 5)
    }

    if (flag === "my_deals") {
      data = data.filter((item) => !(item.status === 5 && item.stakeAmount === 0))
    }

    return data
  } else {
    return null;
  }
}

export const getDealInfo = async (connected, account, dealId) => {
  let _web3 = provierWeb3
  if (connected && account !== '')
    _web3 = web3
  if (_web3) {
    const stakeVault = new _web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    return fetchDealInfo(stakeVault, account, dealId)
  } else {
    return null;
  }
}

export const unStake = async (connected, account, stakeId) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      await stakeVault.methods.withdraw(stakeId).send({ from: account, gasPrice: gasPrice });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}

export const overUnStake = async (connected, account, stakeId) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      await stakeVault.methods.withdrawOverAmount(stakeId).send({ from: account, gasPrice: gasPrice });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}

export const setOfferInfo = async (connected, account, dealId, price, offerTerms) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      const termsUrl = await uploadOfferTermsToIpfs(offerTerms)
      await stakeVault.methods.setOfferInfo(dealId, price, termsUrl).send({ from: account, gasPrice: gasPrice });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}

export const claimDeal = async (connected, account, dealId) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      await stakeVault.methods.claim(dealId).send({ from: account, gasPrice: gasPrice });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}

export const updateDeal = async (connected, account, dealId, dealStatus) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      await stakeVault.methods.updateDealStatus(dealId, dealStatus).send({ from: account, gasPrice: gasPrice });
      return true;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
}

export const addStake = async (connected, account, dealId, amount) => {
  if (web3 && connected && account !== '') {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      let result = []
      await stakeVault.methods.deposit(dealId, amount).send({ from: account, gasPrice: gasPrice })
        .on('receipt', (receipt) => {
          result = ["success", "Stake succeeded!"]
        })
        .on('error', () => {
          result = ["error", "Unfortunately, your transaction has failed. Please try again."]
        });
      return result;
    } catch (error) {
      return ["error", "Transaction cancelled."]
    }
  } else {
    return ["error", "Wallet not connected."]
  }
}

export const checkAllowance = async (connected, account, tokenInfo) => {
  if (web3 && connected && account !== '') {
    const tokenContract = new web3.eth.Contract(tokenInfo.abi, tokenInfo.address);
    try {
      let result = await tokenContract.methods.allowance(account, StakeVault_CONTRACT_ADDRESS).call();
      if (result > 0)
        return true
      else
        return false
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}

export const approveToken = async (connected, account, tokenInfo) => {
  if (web3 && connected && account !== '') {
    const tokenContract = new web3.eth.Contract(tokenInfo.abi, tokenInfo.address);
    const gasPrice = await web3.eth.getGasPrice(); 
    try {
      await tokenContract.methods.approve(StakeVault_CONTRACT_ADDRESS, "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff").send({ from: account, gasPrice: gasPrice });
      return true
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}

export const addDeal = async (connected, account, dealData) => {
  if (web3 && connected && account !== '') {
    const _tokenInfo = TOKENS_INFO.filter((token) => {
      return token.address.toLowerCase() === dealData.crypto.toLowerCase();
    });
    const decimal = parseInt(_tokenInfo[0].decimal)
    const presailAmount = dealData.presailAmount * (10 ** decimal)
    const minsaleAmount = dealData.minsaleAmount * (10 ** decimal)
    const maxsaleAmount = dealData.maxsaleAmount * (10 ** decimal)
    const minStakeAmount = dealData.minStakeAmount * (10 ** decimal)
    const maxStakeAmount = dealData.maxStakeAmount * (10 ** decimal)
    const leadInvestor = dealData.leadInvestor === '' ? ZERO_ADDRESS : dealData.leadInvestor
    const offerPeriod = dealData.offerPeriod * 3600
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);

    const ipfsUrl = await uploadDealInfoToIpfs(dealData, 'new')
    const gasPrice = await web3.eth.getGasPrice(); 
    
    try {
      await stakeVault.methods.addDeal(
        dealData.name,
        ipfsUrl,
        leadInvestor,
        dealData.startBonus,
        dealData.endBonus,
        presailAmount,
        minsaleAmount,
        maxsaleAmount,
        [minStakeAmount, maxStakeAmount],
        offerPeriod,
        dealData.crypto
      ).send({ from: account, gasPrice: gasPrice });

      return await getDealList(account, "my_deals")
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}

export const modifyDeal = async (connected, account, dealId, dealData, isLeadStaked) => {
  if (web3 && connected && account !== '') {
    const _tokenInfo = TOKENS_INFO.filter((token) => {
      return token.address.toLowerCase() === dealData.crypto.toLowerCase();
    });
    const decimal = parseInt(_tokenInfo[0].decimal)
    const presailAmount = dealData.presailAmount * (10 ** decimal)
    const minsaleAmount = dealData.minsaleAmount * (10 ** decimal)
    const maxsaleAmount = dealData.maxsaleAmount * (10 ** decimal)
    const minStakeAmount = dealData.minStakeAmount * (10 ** decimal)
    const maxStakeAmount = dealData.maxStakeAmount * (10 ** decimal)
    const leadInvestor = dealData.leadInvestor === '' || isLeadStaked ? ZERO_ADDRESS : dealData.leadInvestor
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const ipfsUrl = await uploadDealInfoToIpfs(dealData, 'edit')
    const gasPrice = await web3.eth.getGasPrice(); 

    try {
      await stakeVault.methods.updateDeal(
        dealId,
        ipfsUrl,
        leadInvestor,
        dealData.startBonus,
        dealData.endBonus,
        presailAmount,
        minsaleAmount,
        maxsaleAmount,
        [minStakeAmount, maxStakeAmount]
      ).send({ from: account, gasPrice: gasPrice });

      return true
    } catch (error) {
      return false
    }
  } else {
    return false
  }
}

export const getEstimatedBonus = async (dealId, amount, tokenInfo) => {
  if (web3) {
    const stakeVault = new web3.eth.Contract(StakeVault_ABI, StakeVault_CONTRACT_ADDRESS);
    const _tokenInfo = TOKENS_INFO.filter((token) => {
      return token.address.toLowerCase() === tokenInfo.address.toLowerCase();
    });
    const decimal = parseInt(_tokenInfo[0].decimal)
    const _amount = amount * (10 ** decimal)

    try {
      const dealInfo = await stakeVault.methods.dealInfo(dealId).call()
      const stakeIds = await stakeVault.methods.getStakeIds(dealId).call()
      const bonus = await getBonus(stakeVault, 0, _amount, stakeIds, dealInfo, "E")
      return bonus.toFixed(2)

    } catch (error) {
      return 0
    }
  } else {
    return 0
  }
}

const fetchDealData = (
  stakeVault,
  account,
  dealIds
) => {
  return dealIds.map((dealId) => {
    return fetchDealInfo(stakeVault, account, dealId)
  });
}

const fetchDealInfo = async (stakeVault, account, dealId) => {
  const id = Number(dealId);
  const dealInfo = await stakeVault.methods.dealInfo(dealId).call();
  const name = dealInfo.name;
  if(name === '')
    return false;
  
  const sponsor = dealInfo.sponsor;
  const ipfsUrl = dealInfo.url;
  const status = Number(dealInfo.status);
  const presaleAmount = Number(dealInfo.amount.preSale);
  const minsaleAmount = Number(dealInfo.amount.minSale);
  const maxsaleAmount = Number(dealInfo.amount.maxSale);
  const minStakeAmount = Number(dealInfo.limit.min);
  const maxStakeAmount = Number(dealInfo.limit.max);
  const startBonus = Number(dealInfo.bonus.start);
  const endBonus = Number(dealInfo.bonus.end);
  const dealToken = dealInfo.stakingToken;
  const leadInvestor = dealInfo.lead.investor;
  const isLeadStaked = dealInfo.lead.isStaked;
  const stakeAmount = Number(dealInfo.totalStaked);
  let offerPeriod = Number(dealInfo.offer.period);

  let desc = '', logo = '', url = '';
  if(isValidUrl(ipfsUrl)) {
    const ipfsDealInfoData = await axios.get(ipfsUrl, {
      'Access-Control-Allow-Origin': '*'
    });
    desc = ipfsDealInfoData.data.desc;
    logo = ipfsDealInfoData.data.logo !== '' ? ipfsDealInfoData.data.logo : DEAL_LOGO;
    url = ipfsDealInfoData.data.url ? ipfsDealInfoData.data.url : '';
  }

  const offerTermsIpfsUrl = dealInfo.offer.terms;
  let offerTerms = '';
  
  if(isValidUrl(offerTermsIpfsUrl)) {
    const ipfsOfferTermsData = await axios.get(dealInfo.offer.terms, {
      'Access-Control-Allow-Origin': '*'
    });
    offerTerms = ipfsOfferTermsData.data.terms
  }

  const stakes = await getAllStakes(
    stakeVault,
    id
  );

  let myStakes = [];
  let stakeCount = 0;

  stakes.forEach(stake => {
    let amount = Number(stake.amount) + Number(stake.restAmount)
    if (amount > 0) {
      if (account !== '' && stake.staker.toLowerCase() === account.toLowerCase()) {
        myStakes.push({
          position: stakeCount + 1,
          ...stake
        });
      }
      stakeCount++;
    }
  });

  let hoursLeft = 0;
  if (status === 2) {
    var blockNumber = await provierWeb3.eth.getBlockNumber();
    var blockInfo = await provierWeb3.eth.getBlock(blockNumber);
    const currentTime = blockInfo.timestamp;

    const offerTime = dealInfo.offer.startDate;
    const restTime = Number(offerTime) + offerPeriod - Number(currentTime);
    hoursLeft = Math.ceil(restTime / 3600);
    hoursLeft = hoursLeft > 0 ? hoursLeft : 0;
  }
  const dealPrice = Number(dealInfo.offer.price);
  offerPeriod = Math.ceil(offerPeriod / 3600)

  return {
    id,
    sponsor,
    logo,
    name,
    url,
    desc,
    leadInvestor,
    isLeadStaked,
    stakeAmount,
    stakeCount,
    stakes,
    myStakes,
    status,
    presaleAmount,
    minsaleAmount,
    maxsaleAmount,
    minStakeAmount,
    maxStakeAmount,
    startBonus,
    endBonus,
    dealToken,
    offerPeriod,
    hoursLeft,
    dealPrice,
    offerTerms
  };
}

const getAllStakes = async (
  stakeVault,
  dealId
) => {
  const stakeIds = await stakeVault.methods.getStakeIds(dealId).call();
  const stakes = await Promise.all(
    stakeIds.map((stakeId) => getStakeInfo(stakeVault, stakeId))
  );
  const allStakes = stakes.filter((s) => Number(s.amount) + Number(s.restAmount) !== 0);
  let total = 0;
  const stakeList = allStakes.map((item, index) => {
    let tmp = {
      ...item,
      position: index + 1,
      stakedAmount: total
    }
    total = total + Number(item.amount) + Number(item.restAmount);
    return tmp;
  })

  return stakeList;
}

const getStakeInfo = async (stakeVault, stakeId) => {
  const stakeInfo = await stakeVault.methods.stakeInfo(stakeId).call()
  const stakeIds = await stakeVault.methods.getStakeIds(stakeInfo.dealId).call()
  const dealInfo = await stakeVault.methods.dealInfo(stakeInfo.dealId).call()
  const bonus = await getBonus(stakeVault, Number(stakeInfo.id), Number(stakeInfo.amount), stakeIds, dealInfo, "N")

  return {
    stakeId: stakeInfo.id,
    dealId: stakeInfo.dealId,
    staker: stakeInfo.staker,
    amount: stakeInfo.amount,
    restAmount: stakeInfo.restAmount,
    isClaimed: stakeInfo.isClaimed,
    bonus: bonus.toFixed(2)
  }
}

// Flag: N => Normal Bonus Logic, E => Estimated Bonus Logic
const getBonus = async (stakeVault, _stakedId, _stakedAmount, stakeIds, dealInfo, flag) => {
  const stakedId = _stakedId
  const presaleAmount = Number(dealInfo.amount.preSale)
  const startBonus = Number(dealInfo.bonus.start)
  const endBonus = Number(dealInfo.bonus.end)
  let stakedAmount = _stakedAmount
  let totalStaked = 0
  let getStakeInfo = []

  for (let i = 0; i < stakeIds.length; i++) {
    if (flag === "N" && stakedId <= Number(stakeIds[i]))
      break;

    getStakeInfo.push(stakeInfoHandler(stakeVault, stakeIds[i]))
  }

  const stakes = await Promise.all(getStakeInfo);
  stakes.map((info) => {
    totalStaked += Number(info.amount)
    return true;
  })

  // console.log('debug', stakedId,stakeIds, stakes )
  if (presaleAmount < totalStaked)
    return 0;

  if (presaleAmount < (totalStaked + stakedAmount))
    stakedAmount = presaleAmount - totalStaked

  const bonus = (startBonus - endBonus) * (presaleAmount - totalStaked - stakedAmount / 2) / presaleAmount + endBonus

  return bonus
}

const stakeInfoHandler = async (stakeVault, id) => {
  return await stakeVault.methods.stakeInfo(id).call()
}

const getDealIdsFromStakes = async (
  stakeVault,
  stakeIds
) => {
  const stakes = await Promise.all(
    stakeIds.map((stakeId) => getStakeInfo(stakeVault, stakeId))
  );
  let dealIds = []
  stakes.map((stake) => {
    if (stake.amount > 0)
      dealIds.push(stake.dealId)

    return true;      
  })

  return Array.from(new Set(dealIds));
}

const uploadDealInfoToIpfs = async (
  data,
  flag
) => {
  // upload logo to the pinata
  let logoUrl = '';

  if(flag !== 'new') {
    logoUrl = data.logo;
  } else {
    if (data.logo !== '') {
      const fileURL = `https://api.pinata.cloud/pinning/pinFileToIPFS`;
      const fileData = new FormData()
      fileData.append("file", data.logo)
      const fileResponse = await axios.post(
        fileURL,
        fileData,
        {
          maxContentLength: "Infinity",
          headers: {
            "Content-Type": `multipart/form-data;boundary=${fileData._boundary}`,
            'pinata_api_key': API_KEY,
            'pinata_secret_api_key': API_SECRET
  
          }
        }
      )
  
      logoUrl = `https://presail.mypinata.cloud/ipfs/${fileResponse.data.IpfsHash}`;
    }
  }

  // upload json data to the pinata
  const jsonURL = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;
  const jsonData = {
    pinataMetadata: {
      name: 'launchboard'
    },
    pinataContent: {
      name: data.name,
      url: data.websiteUrl,
      desc: draftToHtml(convertToRaw(data.desc.getCurrentContent())),
      logo: logoUrl
    },
  };
  const jsonResponse = await axios.post(
    jsonURL,
    jsonData,
    {
      headers: {
        'pinata_api_key': API_KEY,
        'pinata_secret_api_key': API_SECRET
      }
    }
  )

  return `https://presail.mypinata.cloud/ipfs/${jsonResponse.data.IpfsHash}`;
}

const uploadOfferTermsToIpfs = async (
  data
) => {
  // upload json data to the pinata
  const jsonURL = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;
  const jsonData = {
    pinataMetadata: {
      name: 'launchboard'
    },
    pinataContent: {
      name: 'Offer Terms',
      terms: draftToHtml(convertToRaw(data.getCurrentContent())),
    },
  };
  const jsonResponse = await axios.post(
    jsonURL,
    jsonData,
    {
      headers: {
        'pinata_api_key': API_KEY,
        'pinata_secret_api_key': API_SECRET
      }
    }
  )

  return `https://presail.mypinata.cloud/ipfs/${jsonResponse.data.IpfsHash}`;
}